import {
  AgendaSpeaker,
  PublicEventDetailsResponse,
} from '@hubs101/booking-api-skd-client/lib/types';
import { Image, Text, View } from '@react-pdf/renderer';
import { getImageSrc, getSpeakerFullName } from '@utils/fn';

import { styles } from '../../styles';
import { useTranslation } from 'react-i18next';

interface SpeakerPanelProps {
  event: PublicEventDetailsResponse;
  agendaSpeakers: AgendaSpeaker[];
}

const SpeakerPanel = ({ event, agendaSpeakers }: SpeakerPanelProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.bodyContainer}>
      <View
        style={{
          ...styles.leftSideBody,
          backgroundColor: event.design.themeColor,
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <Text style={styles.whiteTitle}>{t('prospectus-title-5')}</Text>
        <View style={styles.whiteBodyLineBar} />
      </View>
      <View
        style={{
          ...styles.rightSideBody,
          gap: 20,
          flexDirection: 'row',
        }}
      >
        <View style={styles.speakersWrapper}>
          {agendaSpeakers?.slice(0, 10)?.map(speaker => {
            const speakerFullName = getSpeakerFullName(
              speaker?.first_name,
              speaker?.last_name
            );
            const speakerJobCompany = [
              speaker?.job?.title,
              speaker?.company?.name,
            ]
              ?.filter(Boolean)
              .join(', ');

            return (
              <View key={speaker.profile} style={styles.speakerItem}>
                <View style={styles.speakerImageWrapper}>
                  {speaker?.images?.picture?.length > 0 && (
                    <Image
                      style={styles.speakerLogo}
                      src={getImageSrc(speaker?.images?.picture)}
                    />
                  )}
                </View>
                <View style={styles.speakerBodyCard}>
                  <View style={styles.speakerName}>
                    <Text style={styles.speakerNameText}>
                      {speakerFullName}
                    </Text>
                  </View>
                  <View style={styles.speakerCompanyName}>
                    <Text style={styles.speakerCompanyNameText}>
                      {' '}
                      {speakerJobCompany}
                    </Text>
                  </View>
                </View>

                <View style={styles.speakerLogoWrapper}>
                  {speaker?.company?.logo?.length > 0 && (
                    <Image
                      style={styles.speakerCompanyLogo}
                      src={getImageSrc(speaker?.company?.logo)}
                    />
                  )}
                </View>
              </View>
            );
          })}
        </View>
      </View>
    </View>
  );
};

export default SpeakerPanel;
